import { Suspense, lazy, memo } from "react";

import { Access } from "../../features/auth/components";
import { Layout } from "../../features/layout";
import { UserStateData } from "../../features/user";

const Content = lazy(() => import("./linking-mc-pay-account.content"));

const checkAccess = (user: UserStateData) => user.authenticated;

function LinkingMcPayAccountPage() {
  return (
    <Access checkAccess={checkAccess}>
      <Layout>
        <Suspense fallback={null}>
          <Content />
        </Suspense>
      </Layout>
    </Access>
  );
}

export default memo(LinkingMcPayAccountPage);
